import type { FaireProductEntity } from "../../entity_types/product";

export const p_5wtjh9ra82: FaireProductEntity = {
  token: "p_5wtjh9ra82",
  type: "product",
  name: "Luxury Gold Plated Geometric Zircon Ring DP25E737",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/151f77098dd327cc7f14e37fb5e59d887a582b217f6790347ee73abb04ca26bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87b62a0a9ae13d71b07d2024b11a41ff28710b93688e876925237a85f7eb4852.jpeg",
    "https://cdn.faire.com/fastly/56af677550d3674be1feb2a74498695a1c88c4a3347a5617fbebe93ecd470d2b.jpeg",
    "https://cdn.faire.com/fastly/8c4f9ab114add3c1b86d474526950b402800334294af1a1cb3152465babfa769.jpeg",
    "https://cdn.faire.com/fastly/8983e09f48293b89bbd4c4b03cdb4826b567c105b00a8d661cd4e3822203839e.jpeg",
    "https://cdn.faire.com/fastly/c1d6f2db34f5bb77aad5e22980c32a912697dd010f1e742310693397379b260a.jpeg",
    "https://cdn.faire.com/fastly/216467c40720a859614f3e5c6c0b95bccb602876a7b716f7a534f7b46a745dce.jpeg",
    "https://cdn.faire.com/fastly/0ac3d0ad86ee64c360ee7a02c68d1731d0a98d3da84841d85270560dcd29c7f3.jpeg",
  ],
  priceDollars: 10.1,
  description:
    "Feature:\n * Luxury\n * Gold Plated\n * Cubic Zircon\n * Geometric\n * No Fading\n * Comfortable\n * Leightweight\n * Casual Outfits, Daily Fitting\n * Gift\n\n Weigh:\n * 10g\n\n Material:\n * Stainless Steel\n\n Package:\n * Package include 1 ring.\n\n Note:\n * Avoid contact with water, perfumes, and chemicals. Store in a dry, cool place and keep away from direct sunlight.\n * Remove before swimming, bathing, or exercising.\n * To clean, gently wipe with a soft, dry cloth.",
  tags: [],
  msrpDollars: 20.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:45.856Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
